import { render } from "./CardProfileForm.vue?vue&type=template&id=0f0f0add"
import script from "./CardProfileForm.vue?vue&type=script&lang=js"
export * from "./CardProfileForm.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\TAfolabi\\Documents\\Projects\\legacy\\partner\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__